module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_4.c4f87844.png";